export enum PlaylistType {
  DEFAULT = "0",
  WEBINAR = "1",
  KAKI_MAKAN = "2",
  SHORT_FORM = "3",
}
